import axios from "axios"
import apiServices from "../services/api.services";

const checkAuth = async () => {
    const TOKEN = localStorage.getItem("token")
    const REFRESH_TOKEN = localStorage.getItem("refresh_token")
    const PUBLIC_ROUTES = ["login", "forgot-password", "register", "documentation"]
    console.log({TOKEN, REFRESH_TOKEN})
    const isPublicPage = PUBLIC_ROUTES.some(r => window.location.href.includes(r))
    let requestInterceptorPromise = axios.interceptors.request.use(function (config) {
        // UPDATE: Add this code to show global loading indicator
        if (config.hasOwnProperty("globalLoading") && config["globalLoading"] === true) {
            document.body.classList.add('loading-indicator');
        }
        return config
    }, function (error) {
        return Promise.reject(error);
    });

    let responseInterceptorPromise = axios.interceptors.response.use(function (response) {
        // UPDATE: Add this code to hide global loading indicator
        document.body.classList.remove('loading-indicator');
        const refreshToken = response.headers['x-refresh-token'];
        const accessToken = response.headers['x-access-token'];
        if (refreshToken) {
            localStorage.setItem('refresh_token', refreshToken);
            axios.defaults.headers.common['x-refresh-token'] = `${refreshToken}`
        }
        if (accessToken) {
            localStorage.setItem('token', accessToken);
            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
        }
        return response;
    }, function (error) {
        // document.body.classList.remove('loading-indicator');
        return Promise.reject(error);
    });

    await Promise.all([requestInterceptorPromise, responseInterceptorPromise])
    if (REFRESH_TOKEN && TOKEN) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${TOKEN}`
        axios.defaults.headers.common['x-refresh-token'] = `${REFRESH_TOKEN}`
        try {
            const response = await apiServices.authCheck();
            return response.status === true;
        } catch (error) {
            console.error('Error in follow-up request:', error);
            return false;
        }
    }
    return false;
}

export default checkAuth